import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface HotTopic {
  id: string;
  title: string;
  content: string | null;
  author_id: string | null;
  category_id: string;
  is_pinned: boolean;
  is_locked: boolean;
  view_count: number;
  reply_count: number;
  last_reply_at: string;
  created_at: string;
  updated_at: string;
  username: string | null;
  avatar_url: string | null;
  category_name: string;
  category_color: string;
  category_slug: string;
  slug: string;
  hot_score: number;
  last_post_id: string | null;
  parent_category_id: string | null;
  parent_category_slug: string | null;
}

export interface PaginatedHotTopicsResult {
  data: HotTopic[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
}

export const useHotTopics = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: ['hot-topics', page, limit],
    queryFn: async (): Promise<PaginatedHotTopicsResult> => {
      // RPCs not available - return empty result
      return {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: page,
      };
    },
    enabled: false, // Disable query since RPCs don't exist
    staleTime: 1000 * 60 * 5,
  });
};